<template>
  <div style="margin: 10px">
    <div>
      <div style="margin-bottom: 5px; margin-top: 5px">
        <el-button @click="excelPost()">导出</el-button>
      </div>
    </div>
    <div class="cdj_div" style="margin-top: 20px">账龄分析-查询条件</div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{ width: '123px', color: 'black' }" :contentStyle="{ width: '42%' }">
      <el-descriptions-item label="房产">
        <div style="display: flex">
          <div @click="houses" v-if="data.house" style="cursor: pointer; color: red" :class="data.house.length > 30 ? 'dade-text' : ''">{{ data.house }}</div>
          <div @click="houses_del" v-if="data.house" style="cursor: pointer; margin-left: 10px">取消选择</div>
          <div @click="houses" v-else style="cursor: pointer">选择房产...</div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="统计方式">
        <Space direction="vertical" size="large">
          <RadioGroup v-model="data.radio">
            <Radio label="1" style="font-weight: 500">按项目导出</Radio>
            <!-- <Radio label="2" style="font-weight: 500">按项目区域导出</Radio> -->
          </RadioGroup>
        </Space>
      </el-descriptions-item>
      <el-descriptions-item label="账龄年份">
        <el-date-picker
              v-model="data.year"
              type="year"
              placeholder="选择年">
            </el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item label="">
      </el-descriptions-item>
    </el-descriptions>
    <!-- 房产 -->
    <house ref="house"></house>
  </div>
</template>

<script>
import House from "@/components/Admin/Forms/common/SelectProjectHouse";
export default {
  name: "FormsChargeSum",
  components: {
    House
  },
  data() {
    return {
      data: {
        year:'',
        house_id: "",
        startDate: "",
        endDate: "",
        payStartDate: "",
        payEndDate: "",
        dayPayStartDate: "",
        dayPayEndDate: "",
        chargeitemID: "",
        chargeitemIDName: "",
        room: "",
        room_id: "",
        radio: "1",
        house: "",
        user: "",
        user_id: "",
        userType: [],
        charge_id: "",
        chargeName: "",
        paymentId: [],
      },
      startDate: "",
      endDate: "",
      payStartDate: "",
      payEndDate: "",
      dayPayStartDate: "",
      dayPayEndDate: "",
      payment: [],
      excelTaskId: "",
      excelTask: false,
      modal1: false,
      house_1: "",
      loading: false,
    };
  },
  mounted() {

  },
  methods: {
    excelPost() {
      if (this.data.house_id == "") {
        this.$Message.error("房产不能为空");
        return false;
      }
      ERP.showLoading();
      this.$myhttp.post("admin/FinancialChart/AgingStatistics", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        }).then((backdata) => {
          window.open(this.$myhttp.defaults.baseURL+""+backdata.data.data, '_blank');
          // 异步执行成功后
          ERP.hideLoading();
        }).catch(function (error) {
          ERP.hideLoading();
          this.$Message.error("出错了");
      });
    },
    //选择房产
    houses() {
      let _this = this;
      this.$refs.house.show([], function (data) {
        //整理项目和房产ID
        _this.$myhttp
          .post("admin/common/house_tree_id", data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            _this.data.house_id = backdata.data.house_ids;
            _this.data.house = backdata.data.ancestor_name;
            _this.data.chargeitemID = "";
            _this.data.chargeitemIDName = "";
            _this.data.charge_id = "";
            _this.data.chargeName = "";
          })
          .catch(function (error) {
            _this.$Message.error("选择房产失败");
          });
      });
    },
    houses_del() {
      this.data.house_id = "";
      this.data.house = "";
    },
  },
};
</script>

<style>
@import "../../../assets/css/table.css";
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}
.dade-text {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/AgingStatistics.vue